module.exports = __webpack_public_path__ + "img/eyyb-s4.72977e90.jpg";